import {CountFormatterOptions} from "./models/CountFormatterOptions";

export function observe(element: HTMLElement) {

    const intersectionObserver = new IntersectionObserver((elements: IntersectionObserverEntry[]) => {
        for (const htmlElement of elements) {
            if (htmlElement.intersectionRatio >= 0.2) {
                htmlElement.target.classList.add('animated')
            }
        }
    }, {
        threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0]
    });

    const elements = element.querySelectorAll('.observer');

    elements.forEach(element => intersectionObserver.observe(element));
}

export function displayElementInView(element: HTMLElement, action: ((entry: IntersectionObserverEntry) => void)) {

    const initClassName = 'displayInView';

    if(!element.classList.contains(initClassName)){
        element.classList.add(initClassName);
    }

    const intersectionObserver = new IntersectionObserver((entries: IntersectionObserverEntry[]) => {
        for (const entry of entries) {
            if (entry.intersectionRatio >= 0.2) {
                action(entry);
            }
        }
    }, {
        threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0]
    });

    intersectionObserver.observe(element);
}

export function getBrowserLocales(): string[] {
    const opt = {
        languageCodeOnly: true
    };
    const browserLocales =
        navigator.languages === undefined
            ? [navigator.language]
            : navigator.languages;
    if (!browserLocales) {
        return [];
    }

    let results:string[] = [];

    const locales = browserLocales.map(locale => {
        const trimmedLocale = locale.trim();
        return opt.languageCodeOnly
            ? trimmedLocale.split(/-|_/)[0]
            : trimmedLocale;
    });

    for(let locale of locales){
        if(!results.includes(locale)){
            results.push(locale);
        }
    }

    return results;
}

export const createCountFormatter = (opts : CountFormatterOptions) => {
    const titles = [opts.one, opts.two, opts.few];
    return (number: number): string => {
        const cases = [2, 0, 1, 1, 1, 2];

        return titles[
            number % 100 > 4 && number % 100 < 20
                ? 2
                : cases[number % 10 < 5 ? number % 10 : 5]
            ];
    };
};